import { Divider, makeStyles, IconButton } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { grey } from '@material-ui/core/colors';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import React, { useState } from 'react';
import CannedTipsButtons from './CannedTipsButtons.jsx';
import NumericTipsInput from './NumericTipsInput.jsx';
import ChowbusDialog from '~/components/ui-kit/ChowbusDialog/ChowbusDialog';
import { mixpanel } from '~/third_party/Mixpanel';

export default Tips;

const useStyles = makeStyles({
  container: {
    width: '100%',
    backgroundColor: '#ffffff',
    border: '1px solid #E1E1E1',
    borderRadius: 10,
    textAlign: 'center',
    marginTop: 20,
  },
  title: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  description: {
    margin: '15px 0 15px',
    width: 'auto',
  },
  divider: {
    marginBottom: 0,
    marginTop: 0,
  },
  link: {
    fontSize: '16px',
    color: '#e00051',
  },
});

function Tips() {
  const classes = useStyles();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  function openDialog() {
    setIsDialogOpen(true);
    mixpanel.track({
      name: `User clicks on Delivery & Driver Support description`,
    });
  }
  function closeDialog() {
    setIsDialogOpen(false);
  }

  return (
    <Grid className={classes.container}>
      <div className={classes.title}>
        <Typography variant='subtitle2' className={classes.description}>
          Support your driver
        </Typography>
        <IconButton onClick={openDialog} size='small'>
          <InfoOutlinedIcon
            style={{
              width: 15,
              height: '100%',
              color: grey[400],
            }}
          />
        </IconButton>
        <ChowbusDialog
          title={'Delivery & Driver Support'}
          isDialogOpen={isDialogOpen}
          onCloseDialog={closeDialog}>
          <Typography>
            {`
            Chowbus drivers will receive 100% of this value in the form of the tips, based on a preferred payout method and frequency that they’ve chosen. For additional information on how gratuities are paid to Chowbus drivers and to third-party delivery services which Chowbus may use from time to time, 
          `}
            <a href={'/faq/delivery-and-driver-support'} className={classes.link}>
              click here
            </a>
            .
          </Typography>
        </ChowbusDialog>
      </div>

      <Divider className={classes.divider} />
      <CannedTipsButtons />
      <NumericTipsInput />
    </Grid>
  );
}
